const config = {
    Sidebar_drawer: true,
    mini_sidebar: false,
    actTheme: 'light',
    fontTheme: 'Roboto sans',
  };
  
  export default config;
  